/**
 * 代理商 api
 */
import * as API from '../'
import $const from '../../common/constant'
export default {
  save:  params => {
    return API.POST($const.apiServer.Tranning + '/video/save', params);
  },
}



// WEBPACK FOOTER //
// ./src/api/video/api_video.js